var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18639 4.18499C6.4349 3.93834 6.83783 3.93834 7.08634 4.18499L10.4803 7.55341C10.7288 7.80005 10.7288 8.19995 10.4803 8.44659L7.08634 11.815C6.83783 12.0617 6.4349 12.0617 6.18639 11.815C5.93787 11.5684 5.93787 11.1685 6.18639 10.9218L9.13035 8L6.18639 5.07817C5.93787 4.83153 5.93787 4.43163 6.18639 4.18499Z",
    fill: "#0E46C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caret-right.dcb9a66f5f7d8a9411ae619c356e6bbe.svg";
export { ForwardRef as ReactComponent };